import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
let {
  TABLE_SELECTED_COLOR,
  TABLE_TEXT_COLOR,
  TABLE_BG_COLOR,
  BUTTON_WHITE_HOVER_BG_COLOR
} = constants;

let styles = {
  base: {
    display: 'flex',
    flexShrink: 0,
    flexWrap: 'wrap',
    alignItems: 'center',
    height: 30,
    width: '100%',
    padding: '0 10px',
    boxSizing: 'border-box',
    backgroundColor: TABLE_SELECTED_COLOR,
    color: TABLE_TEXT_COLOR,
    borderBottom: `1px solid ${TABLE_BG_COLOR}`
  },
  button: {
    flexShrink: 0,
    background: 'none',
    border: '1px solid',
    fontSize: '0.9em',
    textTransform: 'capitalize',
    maxHeight: 25,
    boxSizing: 'border-box',
    fontWeight: 400,
    marginLeft: 'auto',
    padding: '3px 10px',
    ':hover': {
      backgroundColor: BUTTON_WHITE_HOVER_BG_COLOR
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/mapBar/MapBar.styles.js